import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import DogTheProgrammed from '../assets/images/dog-programmer.jpg';

function ContactForm() {
  const [state, handleSubmit] = useForm('xeqylrnp');
  if (state.succeeded) {
    return (
      <div className='my-8'>
        <p className='text-center text-lg text-white pb-4'>
          Thank you for your message. I will respond as fast as I can. In the
          meantime, here is a photo of a Dog 😀
        </p>
        <img
          src={DogTheProgrammed}
          alt='Dog the Programmer'
          className='w-4/5 mx-auto rounded-3xl'
        />
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className='flex flex-col gap-5'>
      <input
        id='name'
        type='name'
        name='name'
        placeholder='Full Name'
        required={true}
        className='border-b-2 border-b-blue-500 bg-transparent text-lg px-2 py-1 outline-none placeholder-inherit'
      />
      <ValidationError prefix='Name' field='name' errors={state.errors} />
      <input
        id='email'
        type='email'
        name='email'
        placeholder='Email'
        required={true}
        className='border-b-2 border-b-blue-500 bg-transparent text-lg px-2 py-1 outline-none placeholder-inherit'
      />
      <ValidationError prefix='Email' field='email' errors={state.errors} />
      <textarea
        id='message'
        name='message'
        required={true}
        rows={4}
        placeholder='Write your message here...'
        className='border-b-2 border-b-blue-500 bg-transparent text-lg px-2 py-1 outline-none placeholder-inherit'
      />
      <ValidationError prefix='Message' field='message' errors={state.errors} />
      <button
        type='submit'
        disabled={state.submitting}
        className='bg-green-500 w-fit px-6 py-2 rounded-2xl mx-auto text-xl'
      >
        Submit
      </button>
    </form>
  );
}

export default ContactForm;
